import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ShipmentTracking from "./ShipmentTracking";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

export default function App() {
  const theme = useTheme();
  const belowMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  //  const getBasename = () => {
  //   return `/${process.env.PUBLIC_URL.split('/').pop()}`;
  // };
const getBasename = () => {
  const url = new URL(process.env.PUBLIC_URL);
  return url.pathname.replace(/\/$/, ""); // remove trailing slash
};
  return (
      <Router basename={getBasename()} >
         {/* <Router> */}
        {/* <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
                 maxWidth:'100vw'
          }}
        >
          <Box> */}
            <Routes>
              <Route path="/" element={<ShipmentTracking />} />
               <Route path="/:db/:trackno" element={<ShipmentTracking />} />
            </Routes>
          {/* </Box>
        </Box> */}
      </Router>

  );
}
